/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Doc_Tow_InvoiceInputs */

const en_case_doc_tow_invoice = /** @type {(inputs: Case_Doc_Tow_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tow/rental invoice`)
};

const pt_br2_case_doc_tow_invoice = /** @type {(inputs: Case_Doc_Tow_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NF guincho/locação`)
};

/**
* | output |
* | --- |
* | "Tow/rental invoice" |
*
* @param {Case_Doc_Tow_InvoiceInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_doc_tow_invoice = /** @type {((inputs?: Case_Doc_Tow_InvoiceInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Doc_Tow_InvoiceInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_doc_tow_invoice(inputs)
	return pt_br2_case_doc_tow_invoice(inputs)
});